import React from 'react'
import { Button, Container, Icon, IconStack, Modal, Spacer, Text } from 'roadie-ui'
import { ProfileVehicle } from 'types/profile'
import { ModalOptions } from 'types/global'
import { getVehicleCategoryIcon } from './Vehicles'
import { usePendingPlateLookupModalViewModel } from './hooks/usePendingPlateLookupModalViewModel'
import { LocalizedRichText, LocalizedText } from 'localization'

export const PendingPlateLookupModal: React.FC<{
  vehicle: ProfileVehicle
  modalOptions: ModalOptions
  setModalOptions: React.Dispatch<React.SetStateAction<ModalOptions>>
}> = ({ vehicle, modalOptions, setModalOptions }) => {
  const { isWebView, handleAccept, handleAddInsurance, handleClose } = usePendingPlateLookupModalViewModel({
    vehicle,
    setModalOptions,
  })

  return (
    <Modal.Basic
      open={modalOptions.modalOpen && modalOptions.modalType === 'pending-plate-lookup'}
      width={isWebView ? '350px' : '500px'}
    >
      <Container.Base $maxHeight="90vh">
        <Container.Position $position="absolute" $top="1.4rem" $right="1.4rem">
          <Button.Tertiary type="button" onClick={handleClose} data-cy="pending-plate-modal-close-icon">
            <Icon.Close $width="2rem" $height="2rem" $color="neutral-darker" />
          </Button.Tertiary>
        </Container.Position>
        <Spacer $height="1.4rem" />
        <Container.Grid $alignItems="center" $justifyItems="center">
          <Container.Base $width="7rem" $height="7rem">
            <IconStack>
              <Container.Base $borderRadius="100%" $backgroundColor="primary-lighter" $height="100%" />
              <Container.Base $color="primary-dark" $padding=".75rem">
                {getVehicleCategoryIcon(vehicle.specs.category, vehicle.specs.model, vehicle.details.vin ?? null)}
              </Container.Base>
            </IconStack>
          </Container.Base>
          <Spacer $height="2.4rem" />
          <Text.H4 $fontWeight="700" $color="neutral-black" $textAlign="center">
            <LocalizedRichText
              translationKey="dweb_account_driving_info_new_vehicle_add_value1_profile"
              params={{ value1: vehicle.plate_lookup.display_name }}
            />
          </Text.H4>
          <Spacer $height="2.4rem" />
          <Text.Caption $textAlign="center">
            <LocalizedText translationKey="dweb_account_driving_info_new_vehicle_vehicle_we_found_from_info_provided_if_not" />
          </Text.Caption>
        </Container.Grid>
        <Spacer $height="2.4rem" />
        <Container.Base $width="100%">
          <Button.Primary $width="100%" onClick={handleAccept} data-cy="pending-plate-confirm-button">
            <LocalizedText translationKey="dweb_account_driving_info_new_vehicle_yes_add_vehicle" />
          </Button.Primary>
          <Spacer $height="2.4rem" />
          <Button.Secondary $width="100%" onClick={handleAddInsurance} data-cy="pending-plate-add-insurance-button">
            <LocalizedText translationKey="dweb_account_driving_info_new_vehicle_no_add_proof_insurance" />
          </Button.Secondary>
          <Spacer $height="2.4rem" />
          <Button.Tertiary $width="100%" onClick={handleClose} data-cy="pending-plate-cancel-button">
            <LocalizedText translationKey="dweb_common_cancel" />
          </Button.Tertiary>
        </Container.Base>
      </Container.Base>
    </Modal.Basic>
  )
}
